import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router';
// import history from '../../history';

import {
  fetchExercise,
  leaveExercise,
  clear,
} from './ExerciseActions';

import ExerciseRun from '../ExerciseRun/ExerciseRun';
import ExerciseWaitingRoom from '../ExerciseWaitingRoom/ExerciseWaitingRoom';

export default function ExerciseWrapper() {
  const connected = useSelector(state => state.socket.connected);
  const exercise = useSelector(state => state.exercise.exercise);
  const dispatch = useDispatch();

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!connected) {
      navigate('/exercises');
      return;
    }

    if (!exercise || !exercise.id) {
      dispatch(fetchExercise(id));
    }

    return () => {
      dispatch(leaveExercise(id));
      dispatch(clear());
    };
  }, []);

  const { status } = exercise || {};

  if (status === 'RUNNING') {
    return <ExerciseRun id={id} />;
  }

  return <ExerciseWaitingRoom id={id} />;
}
